import { useTranslation } from "react-i18next";
import singleMode from "./selectBaseSingle";
import { rawItems } from "../filters/useFilterKids";

export default ({ initial }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);
	const items = rawItems.map(item => ({
		...item,
		content: t(`filtersAndSelectors:kids.${item.value}`),
	}));

	return {
		rawItems,
		items,
		...singleMode({ items, initial }),
	};
};
